export * from './storage';
export * from './seo';
// export * from './env';
export const DOMAIN_ADS = 'https://web.api.adtimaserver.vn';
export const DOMAIN_URL = 'https://baomoi.com';
export const PHOTO_URL = 'https://photo-baomoi.bmcdn.me';

//URL
export const SUB_DOMAIN_URL = 'baomoi.net.vn';
export const DOMAIN_LITE_URL = 'https://lite.baomoi.com';
export const LOG_URL = 'https://log.baomoi.com';
export const FB_FANPAGE = 'https://www.facebook.com/Baomoi';
export const PREFIX = 'bm';
export const PLATFORM = 'web';
export const GA_TRACKING_ID = 'UA-309591-61';
export const GA4_TRACKING_ID = 'G-KL0ZDVFN4F';

export const SECTION_ID = {
    CONTENT: 5,
    CONTENT_LIST_TOP: 200,
    CONTENT_LIST_MORE: 6,
    CONTENT_FETCH_LIST: 7,
    CONTENT_BY_TOPIC: 80,
    CONTENT_EVENT: 122,
    PODCAST: 20,
    PODCAST_BANNER: 22,
    AD: 170,
};

export const CONTENT_TYPE = {
    TEXT: 'text',
    IMAGE: 'image',
    PHOTO: 'photo',
    VIDEO: 'video',
    AUDIO: 'audio',
    PODCAST: 'podcast',
    AD_NATIVE: 'adNative',
    AD_BANNER: 'adBanner',
};

export type CONTENT_TYPE =
    | 'text'
    | 'image'
    | 'photo'
    | 'video'
    | 'audio'
    | 'podcast'
    | 'adNative'
    | 'adBanner';

export const PAGE_TYPE = {
    CONTENT_DETAIL: 'contentdetail',
    RICH_CONTENT_DETAIL: 'richformat_detail',
};

export const CONTENT_TYPE_VALUE = {
    PHOTO: 1,
    VIDEO: 2,
    LIVE: 4096,
};

export const OBJECT_TYPE = {
    PUBLISHER: '3' as OBJECT_TYPE,
    CLUSTER: '5' as OBJECT_TYPE,
    TOPIC: '7' as OBJECT_TYPE,
};

export type OBJECT_TYPE = '3' | '5' | '7';

export const CONTENT_SUB_TYPE = {
    IMAGE_CAPTION: 'media-caption',
    AUTHOR: 'body-author',
    BODY_BLOCK: 'body-block',
    LIVE_BODY_BLOCK: 'live-body-block',
    TIME_STRING: 'time-string',
    TIME_CAPTION: 'time-caption',
};

export const VIEW_TYPE = {
    GRID: 'grid',
};

export const ERROR_CODE = {
    REQUIRE_LOGIN: -801,
    CLIENT: -99998,
    UNKNOWN: -99999,
};

export const SUPPORT_VIDEO = {
    PROBABLY: 'probably',
    MAYBE: 'maybe',
    CANNOT: '',
};

export const SPEECH_MODE = {
    AUTO: 'auto' as SPEECH_MODE,
    MANUAL: 'manual' as SPEECH_MODE,
};

export type SPEECH_MODE = 'auto' | 'manual';

export const MODAL_ID = 'react-cool-portal';
export const MODAL_CLASS = 'bm-portal-modal';

export const EVENT = {
    PLAYER_PLAY: 'PLAYER_PLAY',
    SCRIPT_AD_LOAD_SUCCESS: 'SCRIPT_AD_LOAD_SUCCESS',
};

export const TOTAL_PAGINATION = 4;

export const PLACE_HOLDER = {
    IMAGE: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
    VIDEO: 'https://baomoi-static.bmcdn.me/web/styles/img/player-default-03.png',
};

export const EXCLUDE_ERROR_CODES = [-801];
